import { array, object, string } from "yup"
import { useValidatorSeeker } from "@app"

import { userSettingsSitesGroupFormData} from "../@signals"


const schema = object({
    name: string().required('Name is required'),
    sites: array().min(1, 'Sites is required')
})

export default function useUserSettingsSitesGroupValidator() {
    const { isValid, errors } = useValidatorSeeker(userSettingsSitesGroupFormData.value, schema)

    return {
        isValid,
        nameError: errors.name || null,
        sitesError: errors.sites || null
    }
}